import { atom } from "recoil";

export const FilterIsShownState = atom<boolean>({
  key: "filterIsShownState",
  default: false,
});
